
import {Coords} from 'components/TimePicker/types';

enum RegionKey {
	austin = 'austin',
	dallas = 'dallas',
	norcal = 'norcal',
	seattle = 'seattle',
	socal = 'socal',
}

export type Region = {
	name: string
	key: RegionKey
	center: Coords;
	zone:
		| 'America/Los_Angeles'
		| 'America/Chicago'
}

export const AllRegions: Region[] = [
	{
		name: 'Austin, TX', key: RegionKey.austin,
		center: {lat: 30.314373, lng: -97.727758},
		zone: 'America/Chicago',
	},
	{
		name: 'Dallas, TX', key: RegionKey.dallas,
		center: {lat: 32.826385, lng: -96.834987},
		zone: 'America/Chicago',
	},
	{
		name: 'Los Angeles, CA', key: RegionKey.socal,
		center: {lat: 34.075233, lng: -118.380173},
		zone: 'America/Los_Angeles',
	},
	{
		name: 'Orange County, CA', key: RegionKey.socal,
		center: {lat: 33.718727, lng: -117.939638},
		zone: 'America/Los_Angeles',
	},
	{
		name: 'San Francisco, CA', key: RegionKey.norcal,
		center: {lat: 37.784909, lng: -122.402654},
		zone: 'America/Los_Angeles',
	},
	{
		name: 'San Jose, CA', key: RegionKey.norcal,
		center: {lat: 37.387842, lng: -121.971981},
		zone: 'America/Los_Angeles',
	},
	{
		name: 'Seattle, WA', key: RegionKey.seattle,
		center: {lat: 47.584030, lng: -122.232529},
		zone: 'America/Los_Angeles',
	},
];
